class News {

    constructor() {
        const latestYear = document.getElementById('latestYear')?.dataset.searchSlug
        if (latestYear) {
            document.querySelectorAll<HTMLElement>(`[data-search="${latestYear}"]`).forEach(elem => {
                elem.style.display = 'block'
            })
        }
        const buttons = document.querySelectorAll<HTMLButtonElement>('.js-trigger-search')
        buttons.forEach(button => {
            button.addEventListener('click', function () {
                const year = button.getAttribute('data-search-slug')
                document.querySelectorAll<HTMLElement>('[data-search]').forEach(elem => {
                    if (elem.dataset.search === year) {
                        elem.style.display = 'block';
                    } else {
                        elem.style.display = 'none';
                    }
                })

                buttons.forEach(btn => btn.classList.remove('button--active'));
                button.classList.add('button--active');
            })
        })
    }
}

export default News;
